import { render } from "./TableShip_fingers.vue?vue&type=template&id=f224347c&scoped=true"
import script from "./TableShip_fingers.vue?vue&type=script&lang=js"
export * from "./TableShip_fingers.vue?vue&type=script&lang=js"

import "./TableShip_fingers.vue?vue&type=style&index=0&id=f224347c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f224347c"]])

export default __exports__